import React, { useEffect, useState } from 'react';
import Checkout from '../../../Components/Payments/Checkout';
import styled from 'styled-components';
import propTypes from 'prop-types';

const PaymentMethodContainer = styled.div`
    margin-top: 100px;
    display: flex;
    height: 600px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
    align-items: center;
`;

const UpdatePaymentMethod = ({ currentAdvertiser }) => {
    return (
        <PaymentMethodContainer>
            <Checkout currentAdvertiser={currentAdvertiser} />
        </PaymentMethodContainer>
    );
};

UpdatePaymentMethod.propTypes = {
    currentAdvertiser: propTypes.shape({}),
};

export default UpdatePaymentMethod;
